import { ReactNode } from 'react';

import { DownloadFormat } from '~modules/media-library/model/DownloadFormat';

type Props = {
  downloadFormat: DownloadFormat;
  isLoading?: boolean;
  children: ReactNode;
};

export function ShareFormatListItemPanel({ isLoading, downloadFormat, children }: Props) {
  return (
    <div className="flex justify-between items-center h-8 font-sans text-black ">
      {isLoading ? (
        <>
          <div className="bg-gray rounded-full h-4 animate-pulse w-1/3" />
          <div className="bg-gray rounded h-6 w-6 animate-pulse" />
        </>
      ) : !!downloadFormat ? (
        <>
          <div className="text-base pr-2 truncate">{downloadFormat.filename}</div>
          {children}
        </>
      ) : (
        <div className="text-red">Unknown error</div>
      )}
    </div>
  );
}
